import { AssetRiskBanner } from 'components/asset-risk-banner';
import { CRMTractsTable } from 'components/crm-tracts-table';
import { useLoadableAtomValue } from 'lib/hooks/useLoadableAtomValue';
import { CRMTractsAndSubtractsResult } from 'types/api-responses';
import { packageCrmTractsAtom } from './atoms';

interface CRMTractsProps {
  packageId: number;
  evaluationCalculationId?: number | null;
}

export const CRMTracts = ({
  packageId,
  evaluationCalculationId,
}: CRMTractsProps) => {
  const crmTractsData = useLoadableAtomValue<
    CRMTractsAndSubtractsResult,
    Error
  >(packageCrmTractsAtom({ packageId, evaluationCalculationId }));

  const isLoading = crmTractsData.state === 'loading';
  const error =
    crmTractsData.state === 'hasError'
      ? crmTractsData.error.message
      : undefined;
  const data =
    crmTractsData.state === 'hasData' ? crmTractsData.data : undefined;

  return (
    <>
      <AssetRiskBanner banner={data?.riskBanner} />
      <CRMTractsTable
        isLoading={isLoading}
        error={error}
        data={data}
        tableId="packages-crm-tracts-table"
      />
    </>
  );
};
